module.exports = __webpack_public_path__ + "static/media/check.667e40e2.png";